/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Destinatario: userId O roleId, nunca los dos ni ninguno
 */
export interface NormativePermissionControllerGrantPermissionRequest { 
    /**
     * Excepción para un usuario concreto
     */
    userId?: number;
    /**
     * Excepción para todos los usuarios de un rol
     */
    roleId?: number;
    /**
     * Nivel de la excepción. Por omisión, view
     */
    level?: NormativePermissionControllerGrantPermissionRequest.LevelEnum;
}
export namespace NormativePermissionControllerGrantPermissionRequest {
    export type LevelEnum = 'view' | 'download' | 'manage';
    export const LevelEnum = {
        View: 'view' as LevelEnum,
        Download: 'download' as LevelEnum,
        Manage: 'manage' as LevelEnum
    };
}


